export class MonthlyDetail {
  constructor(
    private readonly id: number,
    private readonly kind: number,
    private readonly title: string,
    private readonly content: { [key: string]: string | [] },
    private readonly display_date: string,
    private readonly open_datetime: string,
    private readonly permission_id: number,
    private readonly file_url: string | null,
    private readonly update_datetime: string,
    private readonly topic_relations: any
  ) {}

  getMonthlyDetailObject(): any {
    return {
      id: this.id,
      kind: this.kind,
      title: this.title,
      content: this.content,
      display_date: this.display_date,
      open_datetime: this.open_datetime,
      permission_id: this.permission_id,
      file_url: this.file_url,
      update_datetime: this.update_datetime,
      topic_relations: this.topic_relations,
    };
  }
}
